import {createContext, useContext, useEffect, useState} from "react";
import CONFIG from "../config/_config";
import useFetch from "../hooks/useFetch";

const AuthContext = createContext();

const AuthProvider = ({children}) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState("");
    const { response, makeRequest} = useFetch();

    useEffect(() => {
        if (localStorage.getItem("loginToken")){
            const requestData = {
                attemptAutologin: 1,
                token: localStorage.getItem("loginToken")
            }

            makeRequest(CONFIG.apiUrl + 'auth_ajax.php', 'post', requestData);
            // TODO: ERROR FEEDBACK
        }
    }, [])

    useEffect(() => {
        if (response && response.state === 'success'){
            const { user, token } = response.data;
            setUser(user);
            setToken(token);
            localStorage.setItem('loginToken', token);
        }
    }, [response]);

    const loginAction = async (data) => {
        const requestData = {
            ...data,
            attemptLogin: 1
        };

        makeRequest(CONFIG.apiUrl + 'auth_ajax.php', 'post', requestData);

        // TODO: error feedback
        return false;
    }

    const logoutAction = async () => {
        setUser(null);
        setToken('');
        localStorage.removeItem('loginToken');
    }

    return <AuthContext.Provider value={{ token, user, loginAction, logoutAction }}>{children}</AuthContext.Provider>
}

export default AuthProvider;

export const useAuth = () => {
    return useContext(AuthContext)
}